export default __webpack_public_path__ + "static/media/online-uni.594278f9.png";